export interface AuthenticationChallenge {
  challengeType: AuthenticationChallengeType;
  identityProvider?: string;
  additionalInfo?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  idpOverrides?: any;
  error?: Error;
}

export enum AuthenticationChallengeType {
  Failed = 'Failed',
  Password = 'Password',
  SAML = 'SAML',
  Unknown = 'Unknown',
}
